// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4fff349d","140":"5d31e56d","302":"5057e15c","306":"472d9c32","320":"0e00febc","356":"003f9594","384":"41312efc","418":"46353847","575":"71c7527b","706":"c6bc3482","956":"c5d48b11","959":"440c3f39","976":"3b41b53d","993":"0aad8a8c"}[chunkId] + ".chunk.js";
};